import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "../components/Reveal";
import GalleryJobCard from "../components/GalleryJobCard";
import CTASection from "../components/CTASection";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";

const Gallery = () => {
    const [jobs, setJobs] = useState(null);

    useEffect(() => {
        api.get("/gallery").then(({ data }) => setJobs(data)).catch(() => setJobs([]));
    }, []);

    return (
        <main className="bg-brand-ink">
            <Seo
                title="Before & After Stump Grinding Photos"
                description="Real before-and-after photos of stump grinding jobs around Poplar Bluff, MO. Drag the slider to see how each stump looked when we arrived and when we left."
            />
            <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-40 pb-24">
                <Reveal className="mb-14 max-w-3xl">
                    <Eyebrow className="mb-4">Job gallery</Eyebrow>
                    <h1 className="font-display font-black uppercase text-brand-cream text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.92] mb-6">
                        Every stump has <span className="text-brand-amber">an after.</span>
                    </h1>
                    <p className="text-brand-sage text-base sm:text-lg leading-relaxed">
                        Drag the handle on any photo to compare. These are real jobs from
                        our 30-mile radius around Poplar Bluff — no stock "after" shots.
                    </p>
                </Reveal>

                {jobs === null && (
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-moss" data-testid="gallery-loading">
                        Loading jobs...
                    </p>
                )}

                {jobs?.length === 0 && (
                    <div className="rounded-lg border border-dashed border-brand-line p-16 text-center" data-testid="gallery-empty">
                        <p className="font-display font-bold uppercase text-brand-cream text-2xl tracking-tight">
                            Photos coming soon.
                        </p>
                        <p className="text-brand-sage text-sm mt-2">
                            We're adding before-and-after shots from recent jobs. In the meantime,{" "}
                            <Link to="/quote" className="text-brand-amber hover:underline">get a free quote</Link>.
                        </p>
                    </div>
                )}

                {jobs?.length > 0 && (
                    <>
                        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-brand-moss mb-8" data-testid="gallery-count">
                            {jobs.length} job{jobs.length === 1 ? "" : "s"} · newest first
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-testid="gallery-grid">
                            {jobs.map((job, i) => (
                                <GalleryJobCard key={job.id} job={job} index={i} />
                            ))}
                        </div>
                    </>
                )}
            </section>
            <CTASection testid="gallery-cta" />
        </main>
    );
};

export default Gallery;
